import React, { useEffect, useState } from 'react';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import Errors from './Errors.js';
const GenericSelector = (props) => {
    const [id, setId] = useState(props.id);
    useEffect(() => {
        if (props.id !== id) {
            setId(props.id);
        }
    }, [props.id]);
    const model = useMutation(props.mutatationFn, {
        onError: () => {
            setId(props.id);
        },
        onSuccess: () => {
            if (props.onSuccess) {
                props.onSuccess();
            }
        },
    });
    const update = (id) => {
        setId(id);
        model.reset();
        model.mutate(id);
    };
    return (React.createElement(React.Fragment, null,
        model.isError && model.error instanceof Error ? (React.createElement(Errors, { errors: [model.error.message] })) : null,
        React.createElement(props.searchElement, {
            loading: model.isLoading,
            selected: id,
            onSelect: update,
        }),
        props.preview && props.preview(id)));
};
export default GenericSelector;
//# sourceMappingURL=GenericSelector.js.map